export const lang = {
	FAILED: {
		TITLE: 'Payment Failed',
		MESSAGE:
			"We're sorry, the payment failed:<br><br>\n\t\t\t<b>$message</b><br><br>\n\t\t\t$prepaidCardMessage\n\t\t\tDon't worry, you have not been charged. We recommend you review your payment details and try again, please contact support if this persists.",
		PREPAID:
			'It looks like you are using a <b>prepaid card</b>. These are often rejected by banks when registering for subscription services. Please try another card if possible.<br><br>'
	},
	ALREADY_PAID: {
		MESSAGE:
			"Sorry, we haven't charged your card because you already have an active membership! If you want to buy a gift for someone else, please select that option on the plans page."
	},
	UPDATE_SOURCE: {
		MESSAGE: 'Update Payment Details',
		SUCCESS: {
			title: 'Update Succeeded',
			message: 'Thank you, your payment details were updated.',
			messageWasPastDue:
				'Thank you, your payment details were updated. We will now attempt to re-bill you in order to reactivate your subscription.'
		}
	},
	MISSING_EMAIL: 'Please enter a valid email address',
	APPLE_PAY_MESSAGE:
		'Apple Pay is available for Safari users with a stored card, sometimes a refresh may be required.',
	NO_PAYMENT_METHODS:
		'Sorry, no payment methods are available for you for this plan. Please contact support for assistance.',
	COMPLETE_WITH_PAYPAL: 'Click the button below to complete your purchase using PayPal'
};
